import './styles';

import React from 'react';

export default class Gauge extends React.Component {
    static defaultProps = {
        min: 0,
        max: 100,
        value: 0,
        trackWidth: 10,
        transitionDelay: 0,
        transitionDuration: 500,
        circumference: 1,
        framerate: 60
    };

    constructor(props) {
        super(props);

        this.state = {
            currentProportion: 0
        };
    }

    componentDidMount() {
        this.transitionTimeout = window.setTimeout(() => {
            this.transitionTimeout = null;
            this.transitionTo(this.props.value);
        }, this.props.transitionDelay);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value !== this.props.value) {
            if (this.transitionTimeout) window.clearTimeout(this.transitionTimeout);

            this.transitionTimeout = window.setTimeout(() => {
                this.transitionTimeout = null;
                this.transitionTo(newProps.value);
            }, this.props.transitionDelay);
        }
    }

    render() {
        return (
            <div className="Gauge">
                <div className="Gauge-background" />

                <svg xmlns="http://www.w3.org/2000/svg" viewBox={this.viewBox}>
                    <path
                        className="Gauge-track"
                        d={this.backgroundPath}
                        strokeWidth={this.props.trackWidth}
                        fill="none"
                    />
                    <path
                        className="Gauge-filled"
                        d={this.foregroundPath}
                        strokeWidth={this.props.trackWidth}
                        fill="none"
                    />
                </svg>

                <span className="count">{this.props.displayValue}</span>
                <span className="label">{this.props.description}</span>
            </div>
        );
    }

    get backgroundPath() {
        return this.getPath(0, 1);
    }

    get foregroundPath() {
        return this.getPath(0, this.state.currentProportion);
    }

    get viewBox() {
        let topLeft = Number(this.props.trackWidth) * (-1 / 2);
        let right = Number(this.props.trackWidth) + 100;
        let bottom = Number(this.props.trackWidth) + 100;

        return `${topLeft} ${topLeft} ${right} ${bottom}`;
    }

    getPath(startProportion, endProportion) {
        let c = Math.min(this.props.circumference, 0.999);
        let fullAngle = Math.PI * 2 * c;
        let startAngle = fullAngle - startProportion * Math.PI * 2 * c;
        let endAngle = fullAngle - endProportion * Math.PI * 2 * c;

        var x1, x2, y1, y2;
        [x1, y1] = this.angleToCoordinates(startAngle);
        [x2, y2] = this.angleToCoordinates(endAngle);

        let isLong = startAngle - endAngle >= Math.PI ? 1 : 0;

        return `M ${x1} ${y1} A 50 50 0 ${isLong} 1 ${x2} ${y2}`;
    }

    angleToCoordinates(θ) {
        θ = θ + Math.PI * 0.5 || 0;
        θ = θ + (1 - this.props.circumference) * Math.PI;
        let x = 50 + Math.cos(θ) * -50;
        let y = 50 + Math.sin(θ) * 50;

        return [x, y];
    }

    capValueAtMax(val) {
        return val > this.props.max ? this.props.max : val;
    }

    transitionTo(value) {
        let newProportion = this.capValueAtMax(value) / (this.props.max - this.props.min);

        let start = this.state.currentProportion;
        let change = newProportion - start;
        let time = 0;
        let duration = this.props.transitionDuration;

        let doStep = () => {
            time = time + 1000 / this.props.framerate;
            let nextValue = this.ease(time, start, change, duration);
            this.setState({ currentProportion: nextValue });

            if (time < duration) window.setTimeout(doStep, 1000 / this.props.framerate);
        };

        doStep();
    }

    ease(time, start, change, duration) {
        time = time / (duration / 2);

        if (time < 1) {
            return (change / 2) * (time * time) + start;
        } else {
            time -= 1;
            return (change / -2) * (time * (time - 2) - 1) + start;
        }
    }
}
